<span class="timer badge badge-lg" *ngIf="time">
  <p class="m-0">
    <ng-container *ngIf="dutch"> Nog&nbsp; </ng-container>
    <span class="mono">
      {{ expired ? '00:00' : (time | date: 'mm:ss') }}
    </span>
    <span>{{ 'timer.left_to_complete' | transloco }}</span>
  </p>
</span>
